class NavToggle extends HTMLElement {

  target: HTMLElement;

  outsideClickListener: (MouseEvent) => void;
  toggleClickListener: (MouseEvent) => void;

  constructor() {
    super();

    this.outsideClickListener = (e: MouseEvent) => {
      if (!this.target.contains(<HTMLElement> e.target)) {
        this.target.classList.remove('open');

        document.removeEventListener('click', this.outsideClickListener);
        this.addEventListener('click', this.toggleClickListener);
      }
    }

    this.toggleClickListener = (e: MouseEvent) => {
      e.stopPropagation(); // otherwise the outside click handler be called immediately

      // Open navigation
      this.target.classList.add('open');

      // Disable toggle button and enable outside clicks
      this.removeEventListener('click', this.toggleClickListener);
      document.addEventListener('click', this.outsideClickListener);
    }
  }

  attributeChangedCallback() {
    if (!this.hasAttribute('target')) {
      console.warn("No target attribute");
      this.disconnectedCallback();
      return;
    }

    const target = document.getElementById(this.getAttribute('target'));

    if (!target) {
      console.warn(`New target '${this.getAttribute('target')}' does not exist`);
      this.disconnectedCallback();
      return;
    }

    // If new target is not equal to the current target, remove all installed
    // event listeners.
    if (target !== target) {
      this.disconnectedCallback();
    }

    this.connectedCallback();
  }

  connectedCallback() {
    // data-target attribute is not set
    if (!this.hasAttribute('target')) {
      console.warn("No target property set");
      return;
    }

    this.target = document.getElementById(this.getAttribute('target'));

    // Target node could not be found
    if (!this.target) {
      console.warn(`Target '${this.getAttribute('target')}' not found`);
      return;
    }

    // Install initial event listener
    this.addEventListener('click', this.toggleClickListener);
  }

  disconnectedCallback() {
    // Remove attached event listeners
    this.removeEventListener('click', this.toggleClickListener);
    document.removeEventListener('click', this.outsideClickListener);
  }

}

window.customElements.define('nav-toggle', NavToggle, { extends: 'a' });



// WEBPACK FOOTER //
// ./assets/scripts/nav.ts